import React from "react";
import { Instagram, Linkedin, Twitter, Youtube } from "lucide-react";
import { NAV } from "../../data";

export const Footer = ({ settings = {} }) => {
  const socials = [
    { icon: Instagram, label: "Instagram", href: settings.social_instagram },
    { icon: Linkedin, label: "LinkedIn", href: settings.social_linkedin },
    { icon: Twitter, label: "Twitter", href: settings.social_twitter },
    { icon: Youtube, label: "Youtube", href: settings.social_youtube },
  ];
  return (
    <footer data-testid="site-footer" className="relative bg-navy-soft border-t border-white/10 pt-16 pb-8 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-3">
              <img src="/logo.webp" alt="Binara Labs" className="w-11 h-11 object-contain" />
              <span className="font-heading font-extrabold tracking-tight text-lg">BINARA<span className="text-gold">.</span>LABS</span>
            </a>
            <p className="mt-5 text-slate-400 text-sm max-w-sm leading-relaxed">
              Katalisator juara dan profesional. Membina siswa menuju olimpiade sains &amp; logika eksakta (OSN/KSN)
              dan mentransformasi kompetensi SDM korporat.
            </p>
            <p className="mt-4 text-xs text-slate-600">Di bawah naungan PT Skena Pendidikan Berprestasi</p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading font-semibold text-sm uppercase tracking-widest text-slate-300">Navigasi</h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm text-slate-400 hover:text-cyan transition-colors" data-testid={`footer-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}>
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading font-semibold text-sm uppercase tracking-widest text-slate-300">Ikuti Kami</h4>
            <div className="mt-5 flex gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href && s.href !== "#" ? s.href : "#contact"}
                  target={s.href && s.href.startsWith("http") ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={`social-${s.label.toLowerCase()}`}
                  className="grid place-items-center w-11 h-11 rounded-xl border border-white/10 text-slate-400 hover:text-navy hover:bg-gold hover:border-gold transition-all duration-300"
                >
                  <s.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
            <a href="#contact" className="mt-6 inline-flex rounded-full bg-cyan/10 border border-cyan/40 text-cyan px-6 py-2.5 text-sm font-bold hover:bg-cyan hover:text-navy transition-all" data-testid="footer-cta">
              Daftar Sekarang
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Binara Labs. Seluruh hak cipta dilindungi.</p>
          <a href="/admin/login" className="text-xs text-slate-600 hover:text-gold transition-colors" data-testid="footer-admin-link">Portal Admin</a>
        </div>
      </div>

      <div className="pointer-events-none select-none mt-8">
        <div className="font-heading font-black text-[18vw] leading-none text-center text-white/[0.02] tracking-tighter">BINARA</div>
      </div>
    </footer>
  );
};
